import { styled } from 'styled-components';

export const Grid = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
`;
export const Header = styled.header`
    width: 100vw;
    background: var(--color-white);
    padding: 1rem;
    color: var(--color-white);
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Main = styled.main`
    max-width: 100vw;
    overflow: hidden;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
`;
